/**
 * Constrói a URL do Google Maps com o endereço fornecido
 * @param {string} address - Endereço formatado (ex: "Rua Exemplo, 123, Condomínio ABC")
 * @returns {string|null} URL do Google Maps ou null se o endereço estiver vazio
 */
export const buildMapsUrl = address => {
  if (!address || !address.trim()) return null;
  const encodedAddress = encodeURIComponent(address.trim());
  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
